import { useState, useCallback } from 'react';
import api from '../api/client';

/**
 * Hook for search functionality
 */
export function useSearch() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = useCallback(async (params) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.search(params);
      setResults(response.data);
    } catch (err) {
      setError(err.message || 'Search failed');
      setResults(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clear = () => {
    setResults(null);
    setError(null);
  };

  return {
    results,
    loading,
    error,
    search,
    clear,
  };
}

export default useSearch;
